import React, { useEffect, useRef } from 'react';

function RevenueFilterPopup({ fromDate, toDate, onFromDateChange, onToDateChange, onReset, onClose }) {
  const containerRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        onClose();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  return (
    <div
      className="popup-dropdown filter-dropdown"
      ref={containerRef}
      style={{
        position: 'absolute',
        top: '100%',
        left: '220px',
        marginTop: '8px',
        width: '310px',
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        border: '1px solid #cbd5e1',
        boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
        padding: '16px',
        zIndex: 100
      }}
    >
      <div
        className="popup-dropdown-header"
        style={{
          display: 'flex',
          justify: 'space-between',
          alignItems: 'center',
          marginBottom: '14px',
          paddingBottom: '10px',
          borderBottom: '1px solid #f1f5f9'
        }}
      >
        <span style={{ fontWeight: '700', fontSize: '14px', color: '#0f172a' }}>Date Range Filter</span>
        <button
          type="button"
          onClick={onReset}
          style={{
            background: 'none',
            border: 'none',
            color: '#0b66e3',
            fontSize: '12px',
            fontWeight: '600',
            cursor: 'pointer'
          }}
        >
          Reset All
        </button>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <div>
          <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: '#475569', marginBottom: '4px' }}>
            From Date:
          </label>
          <input
            type="date"
            className="form-control"
            value={fromDate || ''}
            onChange={(e) => onFromDateChange(e.target.value)}
            style={{
              width: '100%',
              padding: '8px 12px',
              borderRadius: '8px',
              border: '1px solid #cbd5e1',
              fontSize: '13px'
            }}
          />
        </div>

        <div>
          <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: '#475569', marginBottom: '4px' }}>
            To Date:
          </label>
          <input
            type="date"
            className="form-control"
            value={toDate || ''}
            onChange={(e) => onToDateChange(e.target.value)}
            style={{
              width: '100%',
              padding: '8px 12px',
              borderRadius: '8px',
              border: '1px solid #cbd5e1',
              fontSize: '13px'
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default RevenueFilterPopup;
